// extracted by mini-css-extract-plugin
module.exports = {"root":"categories-module__root--1r8bl","sub-wrapper":"categories-module__sub-wrapper--3JeWo","sub-sub-wrapper":"categories-module__sub-sub-wrapper--2zvp7"};